import { Box, Container, Grid, styled, useTheme } from "@mui/material";

import { login } from "config/authentication";

import { useEffect } from "react";

function SanaAnimationLoading() {
  const theme = useTheme();
  useEffect(() => {
    setTimeout(() => {
      login();
    }, 3000);
  }, []);

  return (
    <Container>
      <Grid container>
        <GridStyle item xs={12}>
          <svg
            width="336"
            height="44"
            viewBox="0 0 336 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30.5 1V0.5H30H12.5C10.201 0.5 5.0552 1.86234 2.54925 7.28348C1.84297 8.70124 0.775959 12.3965 2.02225 16.1479C2.72696 18.5994 5.67684 23.6613 11.9339 24.4956L11.9668 24.5H12H28.5C30.4101 24.5 35.1666 25.3737 38.6464 28.8536L39.8142 30.0213L39.4903 28.4019C39.3154 27.5273 38.6647 25.3964 37.4151 23.7202C36.2768 21.8535 31.9819 18.5 23.5 18.5H12.0214C11.1185 18.42 9.77128 17.9827 8.70038 16.9308C7.6399 15.8891 6.80923 14.205 6.99838 11.5406C7.15345 9.85728 8.5654 6.38155 13.0211 6H30H30.5V5.5V1ZM34.6581 28.0257L33.8081 27.7423L34.0133 28.6145C34.7804 31.8748 33.9712 33.898 32.7448 35.1356C31.4933 36.3985 29.7326 36.9187 28.4841 37H3H2.5V37.5V42V42.5H3H28.5H28.5616L28.6213 42.4851C35.1585 40.8508 38.2312 37.0183 38.9642 35.1857C39.1471 34.7286 39.3607 33.9791 39.4235 33.1765C39.4854 32.3844 39.4068 31.4588 38.916 30.7227C38.4475 30.0199 37.6098 29.4307 36.819 28.9886C36.0134 28.5381 35.1842 28.201 34.6581 28.0257ZM39.0572 41.7678L38.6732 42.5H39.5H45H45.3033L45.4434 42.2311L63.4979 7.58603L78.6793 37H57.5H57V37.5V42V42.5H57.5H87H87.8179L87.445 41.7721L66.445 0.772062L66.3057 0.5H66H61H60.6976L60.5572 0.767795L39.0572 41.7678ZM82 0.5H81.5V1V23.5V24H82H86.5H87V23.5V8.99424L112.101 42.3009L112.251 42.5H112.5H118.5H119V42V1V0.5H118.5H113.5H113V1V34.5113L87.3986 0.698181L87.2486 0.5H87H82ZM120.557 41.7678L120.173 42.5H121H126.5H126.803L126.943 42.2311L144.998 7.58603L160.179 37H139H138.5V37.5V42V42.5H139H168.5H169.318L168.945 41.7721L147.945 0.772062L147.806 0.5H147.5H142.5H142.198L142.057 0.767795L120.557 41.7678ZM201.5 6H202V5.5V1V0.5H201.5H183H182.981L182.962 0.501473C177.67 0.908508 173.619 3.03905 172.208 4.09422C161.564 11.4688 162.32 23.2058 164.026 28.1581C167.714 39.6254 177.86 42.5 182.5 42.5H201.5H202V42V37.5V37H201.5H182.033C176.198 36.2135 172.755 33.467 170.797 30.3821C168.822 27.2702 168.338 23.7806 168.499 21.5356L168.499 21.5259L168.5 21.5161C168.695 15.4639 171.167 11.6437 174.146 9.30586C177.142 6.9555 180.68 6.08214 183.009 6H201.5ZM205.057 41.7678L204.673 42.5H205.5H210.5H210.805L210.945 42.2285L229.004 7.08567L244.674 37H223.5H223V37.5V42V42.5H223.5H253H253.827L253.443 41.7678L231.943 0.767795L231.802 0.5H231.5H227H226.698L226.557 0.767795L205.057 41.7678ZM284.5 1V0.5H284H266H265.951L265.902 0.50971C257.612 2.16765 255.505 8.81978 255.5 11.9879C255.296 16.3434 256.991 19.2793 259.215 21.1571C261.42 23.0187 264.123 23.8235 265.953 23.9977L265.976 24H266H280.5C286.344 24 290.722 26.9293 292.146 28.3536L293.25 29.4568L292.993 27.9178C292.36 24.1205 289.935 21.756 287.216 20.3555C284.51 18.9614 281.478 18.5 279.5 18.5H267C264.15 18.5 262.517 17.4024 261.597 16.0883C260.657 14.7454 260.422 13.117 260.499 12.0356C260.687 9.39817 261.889 7.87559 263.288 7.01305C264.713 6.13401 266.378 5.9211 267.464 5.99873L267.482 6H267.5H284H284.5V5.5V1ZM288.621 28.0149L287.874 27.828L288.008 28.5869C288.584 31.8544 287.737 33.8928 286.529 35.1394C285.302 36.4039 283.64 36.9192 282.483 37H257H256.5V37.5V42V42.5H257H282.476C284.628 42.707 286.653 41.8522 288.28 40.7517C289.912 39.6481 291.199 38.2609 291.898 37.3035C292.261 36.8473 292.758 36.0565 293.117 35.1157C293.477 34.1715 293.716 33.0287 293.49 31.9019C293.251 30.7033 292.32 29.8144 291.37 29.2043C290.408 28.5861 289.33 28.1921 288.621 28.0149ZM303 1V0.5H302.5H298H297.5V1V42V42.5H298H302.5H303V42V21.5H330V42V42.5H330.5H335H335.5V42V1V0.5H335H330.5H330V1V16H303V1Z"
              stroke={theme.palette.text.main}
            />
          </svg>
        </GridStyle>

        <Versioning>V2.0.0</Versioning>
      </Grid>
    </Container>
  );
}

const GridStyle = styled(Grid)(({ theme }) => ({
  width: "100%",
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  strokeDasharray: 487,
  strokeDashoffset: 487,

  svg: {
    maxWidth: "90%",
    animation: "complete-big-line 3s ease-in-out alternate infinite",
  },

  "@keyframes complete-big-line": {
    "0%": {
      strokeDashoffset: 487,
    },
    "100%": {
      strokeDashoffset: 0,
    },
  },
}));

const Versioning = styled(Box)(({ theme }) => ({
  position: "fixed",
  bottom: "20px",
  right: "20px",
  color: theme.palette.text.secondary,
  fontSize: "12px",
}));

export default SanaAnimationLoading;
